
import PromotionPage from '~/pages/_lang/promotions/_url.vue'
export default PromotionPage
